import { render, staticRenderFns } from "./radio-pc.vue?vue&type=template&id=37aa9c8a"
import script from "./radio-pc.vue?vue&type=script&lang=ts"
export * from "./radio-pc.vue?vue&type=script&lang=ts"
import style0 from "./radio-pc.vue?vue&type=style&index=0&id=37aa9c8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports